import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({

    // Scrollbar
    '@global': {
        '*::-webkit-scrollbar': {
            width: '0.4em'
        },
        '*::-webkit-scrollbar-track': {
            '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)'
        },
        '*::-webkit-scrollbar-thumb': {
            backgroundColor: 'rgba(0,0,0,.1)',
            outline: '1px solid slategrey',
        }
    },

    // Barra de opcion

    dir: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        margin: "auto"
    },
    back_home: {
        paddingLeft: "10px",
        maxWidth: "20px",
    },
    back_home_container: {
        maxWidth: '60px',
        minWidth: '60px',
        maxHeight: '35px',
        minHeight: '35px'
    },
    title: {
        color: "white",
        filter: "drop-shadow(3px 3px 2px #000000c4)",
        margin: "20px"
    },

    // Practica

    paper_practice: {
        width: "900px",
        padding: "20px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        margin: "auto"
    },

    preview: {
        maxWidth: "625px",
        marginBottom: "25px",
        backgroundColor: "#a2e9e13d",
        borderRadius: "8px",
        border: "2px solid #5a858011",
        padding: "20px",
        /* Para evitar copia-pega usuario   */
        pointerEvents: "none",
        userSelect: "none",
        fontSize: "18px"

    },
    row_1: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center"
    },
    row_2: {
        margin: "10px 0px",
    },
    card_selection: {
        display: "flex",
        padding: "10px 10px 0px",
        overflowX: "auto",
        width: "600px",
        WebkitOverflowScrolling: "touch"
    },
    card_to_select: {
        minWidth: "150px",
        minHeight: "50px",
        margin: "0px 5px 15px",
        cursor: "pointer",
        textAlign: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "0px 10px"
    },
    main_section: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    url_select: {
        minWidth: "250px",
        margin: "10px 0px 20px",
        zIndex: 2,

    },
    practice_tag: {
        width: "250px",
        margin: "10px 10px 20px",
    },
    field: {
        marginTop: "20px",
        width: "100%",
        maxWidth: "500px",
    },

    // RSS

    paper_container: {
        width: "650px",
        margin: "0px auto 25px",
        filter: "drop-shadow(2px 2px 5px #ffffff)",
    },
    probar_rss: {
        margin: "0px 20px",
    },
    paper_form: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: "20px",
        border: "1px solid black",
        filter: "drop-shadow(3px 3px 2px #0000005b)",
    },
    form_row: {
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        padding: "10px",
    },
    form_name: {
        width: "300px",
        margin: "0px 10px",
    },
    form_rss: {
        width: "200px",
        margin: "0px 10px",
    },
    form_lang: {
        width: "200px",
        margin: "0px 10px",
    },
    form_tags: {
        width: "200px",
        margin: "0px 10px",
    },
    rss_paper: {
        marginBottom: "16px",
        padding: "5px 18px 12px",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        alignItems: "center",
        "& p": {
            padding: "5px 10px",
            borderRadius: "5px",
            border: "2px solid rgba(0, 0, 0, 0.219)",
            backgroundColor: "#44d1c144",
        }
    },
    add: {
        color: "#006459",
        filter: "drop-shadow(3px 3px 2px #51bbafa6)",
    },
    post_row: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        height: "50px",
    },
    post_new_row: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        margin: "0px 0px 0px 13px",
        width: "600px"
    },
    post_news_row: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        margin: "8px 0px 0px 13px",
        width: "600px",
    },
    post_title: {
        maxWidth: "290px",
        fontWeight: "bold",
        fontSize: "20px"
    },
    post_tag: {
        maxWidth: "232px",
        display: "flex",
        alignItems: "center",
        whiteSpace: "nowrap",
        margin: "8px 0px",
    },
    post_new_tag: {
        display: "flex",
        alignItems: "center",
        whiteSpace: "nowrap",
        margin: "12px 0px",
    },
    post_tag_content: {
        display: "flex",
        overflow: "hidden",
    },
    post_new_tag_content: {
        display: "flex",
        overflowX: "auto",
        width: "541px",
    },
    post_tag_button: {
        height: "35px",
        margin: "5px",
        borderRadius: "5px",
        padding: "0px 8px",
        border: "2px solid rgba(0, 0, 0, 0.219)",
        backgroundColor: "#44d1c144",
    },
    post_users: {
        display: "flex",
        alignItems: "center",
        width: "587px",
        whiteSpace: "nowrap",
        minHeight: "30px"
    },
    post_users_content: {
        display: "flex",
        overflow: "hidden",
    },
    post_new_users_content: {
        display: "flex",
        flexWrap: "wrap",
        maxHeight: "55px",
        overflow: "auto"
    },
    post_users_button: {
        height: "35px",
        padding: "0px 10px",
        margin: "0px 5px",
        backgroundColor: "#ffffff",
        borderRadius: "5px",
        border: "1px solid gray"
    },
    add_button_container: {
        marginLeft: "-10px",
    },
    tag_icon: {
        padding: "0px 8px 0px 6px",
    },
    people_icon: {
        padding: "0px 8px 0px 6px"
    },
    example_news: {
        marginBottom: "20px",
        padding: "10px 20px",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        alignItems: "center",
        "& p": {

            borderRadius: "5px",
            border: "2px solid rgba(0, 0, 0, 0.219)",
            backgroundColor: "#44d1c144",
        }
    },
    // Backdrop

    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
        backgroundColor: "#03040ac4",
        display: "flex",
        flexDirection: "column"
    },
    span: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        marginTop: "10px",
        overflow: "auto"
    },
    img1: {
        width: 800,
        filter: "drop-shadow(3px 3px 2px black)",
        borderRadius: "5px",
        border: "1px solid black"
    },
    img2: {
        width: 800,
        filter: "drop-shadow(3px 3px 2px black)",
        borderRadius: "5px",
        border: "1px solid black"
    },
    img3: {
        width: 800,
        filter: "drop-shadow(3px 3px 2px black)",
        borderRadius: "5px",
        border: "1px solid black"
    },
    paper: {
        margin: 5,
        paddingRight: 30,
        paddingLeft: 30,
    },
    imgcontainer: {
        width: 800,
        height: 350
    },

    // Pagination

    pagination: {
        width: "100%",
        display: "flex",
    },
    pagination_paper: {
        display: "flex",
        flexDirection: "column",
        padding: "10px 20px",
        margin: "0px 20px",
        width: "350px",

    },
    pagination_content: {
        display: "inline-flex",
        justifyContent: "center",
        alignItems: "center",
        margin: "10px",
    },
    pagination_core: {
        maxWidth: "350px",
        marginRight: "20px",
    },
    ul: {
        justifyContent: "space-between",
    },
    search_bar: {
        borderRadius: 4,
        margin: '8px 0px',
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: '12px 16px'
    },
    search_button: {
        height: "45px",
        width: "45px",
        margin: "12px 10px",
    },
    search_text: {
        margin: "5px 10px",
        width: "100%",
    },
    search_tag: {
        margin: "5px 10px",
        width: "100%",
    },
    search_rss: {
        margin: "5px 10px",
        width: "100%",
    },
    navigation2: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "flex-start",
        margin: "10px 10px 0px 0px",
    },
    locked_anadir: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "lightgray"
    },

    // Navigation

    navigation: {
        borderRadius: "5px",
        backgroundColor: "transparent",
    },
    navigation_item: {
        color: "black",
        "&.Mui-selected": {
            color: "white",
        }
    },
    anadir: {
        marginTop: "45px",
        minWidth: "1000px"
    },
    aviso_correcto: {
        color: "green",
        fontSize: "18px",
        fontWeight: "bold",
    },
    aviso_incorrecto: {
        color: "tomato",
        fontSize: "18px",
        fontWeight: "bold",
    },
    visibility_icon: {
        color: "#ffffff"
    },
    lang_icon: {
        width: "18px",
        opacity: "0.5",
        margin: "0px 3px"
    },
    need_to_add_news_arrow: {
        fontSize: "50px",
        color: "green"
    }
}))